import React from 'react';
import './Hero.css';


const Subject = ({ title, description }) => {

  return (
    <section className="relative ">
      <div className="relative">
        <h1 className="text-3xl pl-10 mt-12 w-5/6 lg:w-5/6 md:w-5/6 sm:pl-5 md:pl-10 lg:pl-20 sm:mt-6 md:mt-12 lg:mt-24 sm:text-4xl md:text-4xl text-[#0F172A] font-bold font-poppins  sm:mb-8 leading-snug sm:leading-tight">
        {title}  
        </h1>
        <p className="text-base pl-10 w-5/6 lg:w-5/6 md:w-5/6  sm:pl-5 md:pl-10 lg:pl-20 sm:text-md md:text-xl text-[#211E33] mb-4 sm:mb-6 leading-normal">
        {description}
        </p>
      </div>
    </section>

  );
};

export default Subject;
